import cn from 'classnames'
import React, { useContext } from 'react'

//
import { SiteDataContext } from '../../components/page-wrapper'
import { getMicroCopy } from '../../utils/microcopy'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

const Hamburger = ({ isOpen = false, toggleIsOpen = () => null, classes = '' }) => {
  const microCopyData = useMicroCopyData()
  const { lang } = useContext(SiteDataContext)
  const microKey = isOpen ? 'close' : 'open'

  return (
    <button
      onClick={toggleIsOpen}
      className={cn('c-hamburger', classes, {
        open: isOpen
      })}
      aria-label={getMicroCopy({ key: microKey, fallback: 'Close', data: microCopyData[lang] })}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  )
}

export default Hamburger
